import { useParams, useLocation } from "react-router-dom";
import SideBar from "../Components/SideBar";
import TerminalForm from "../Components/terminalDashboard/TerminalForm";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchTerminalConfigs } from "../Services/terminal";
import { get } from "lodash-es";
import useZoomDisable from "../hook/useZoomDisable";

const TerminalConfigContext = createContext();
export const useTerminalConfig = () => useContext(TerminalConfigContext);

const NewTerminalConfigs = () => {
    const { id } = useParams();
    const location = useLocation();
    const { isAdmin } = location.state || {};
    const [terminalConfig, setTerminalConfig] = useState({
        id: 0,
        name: '',
        terminalId: id,
        logo_url: null,
        header_url: null,
        background_url: null,
        cityId: null,
        lang: '',
        createdAt: '',
        link: '',
        updatedAt: '',
        categoryIds: [],
        selectedCategoriesIds: [],
        serviceIds: [],
        selectedServices: [],
        qrCodeLabel: undefined,
        serviceLabel: undefined,
        scrapers: [],
        query: '',
        orientation: null,
        qrIds: [],
        adIds: [],
        template: "",
        createdBy: "",
        isAdmin: isAdmin
    });
    async function getFetchTerminalConfigs() {
        try {
            const res = await fetchTerminalConfigs(id);
            setTerminalConfig((prev) => ({ ...prev, ...res.data.data }));
        } catch (err) {
            console.error("Failed to fetch terminal configs:", err);
        }
    }
    useZoomDisable();
    useEffect(() => {
        if (id) {
            getFetchTerminalConfigs();
        }
    }, [])

    return <div className="bg-gray-800 body-font relative min-h-screen">
        <SideBar />
        <div className="container w-auto px-5 py-2 bg-gray-900">
            <TerminalConfigContext.Provider value={{ terminalConfig, setTerminalConfig }}>
                <TerminalForm refetch={getFetchTerminalConfigs}/>
            </TerminalConfigContext.Provider>
        </div>
    </div>
};

export default NewTerminalConfigs;
